export default "__VITE_ASSET__5cb6fbdc__"